import { HttpStatusCode } from "@next-platform/packages-ts-types";
import { PageBlockTransportErrorCategory } from "./PageBlockTransportErrorCategory";
/**
 * Row-level consequence of a failed block content request: `empty` hides the
 * failure from the user, `transient` is eligible for one automatic retry and
 * `error` surfaces a retry action.
 */
export const PageRowFailureKind = {
    EMPTY: "empty",
    ERROR: "error",
    TRANSIENT: "transient",
};
const EMPTY_ROW_HTTP_STATUSES = new Set([HttpStatusCode.UNAUTHORIZED, HttpStatusCode.FORBIDDEN, HttpStatusCode.NOT_FOUND]);
export default function classifyPageBlockContentFailure({ category, httpStatus }) {
    if (category === PageBlockTransportErrorCategory.TRANSIENT) {
        return PageRowFailureKind.TRANSIENT;
    }
    if (category === PageBlockTransportErrorCategory.TERMINAL && httpStatus !== undefined && EMPTY_ROW_HTTP_STATUSES.has(httpStatus)) {
        return PageRowFailureKind.EMPTY;
    }
    return PageRowFailureKind.ERROR;
}
